import $store from '@/store';
import AlertsV2Utils from '@/components/AlertsV2/alertsV2Utils';
import DatabaseTypes from '@/utils/databaseTypes';
import { SubTypes } from '@/utils/capabilties/vm/constatnts';
import WSMTypes from '@/store/modules/wsm/wsmTypes';
import { messageQueueList } from '@/components/MQ/mq.types';

export function redirectToGeneratedAlert(service, selectedService) {
  const selectedAlertCapability = AlertsV2Utils.CurrentAlertCapabilityFromVal(
    service.type,
  );
  $store.commit(
    'alertV2State/configure/setCurrentAlertCapability',
    selectedAlertCapability,
  );
  $store.commit(
    'alertV2State/configure/setCurrentAlertApplication',
    selectedService,
  );
  if (service.type === 'C') {
    $store.commit('alertV2State/configure/setCurrentSubType', service.sub);
  }
}

export function setRedirectionServiceWithPermissions(
  to,
  serviceId,
  service,
  permissionList,
  category = '',
) {
  const selectedService = {
    key: serviceId,
    label: service['name'],
    permissions: permissionList,
  };
  const getDurationTime =
    $store.getters['globalState/settings/getDurationTime'];
  const params = {
    duration: getDurationTime,
    service: selectedService,
  };
  if (to.name == 'generatedV2') {
    redirectToGeneratedAlert(service, selectedService);
  } else {
    switch (service.type) {
      case 'A': {
        $store.dispatch('apmState/apmCommonState/selectService', params);
        break;
      }
      case 'B': {
        $store.dispatch(
          'browserState/browserCommonState/selectBrowserService',
          params,
        );
        break;
      }
      case 'D': {
        const dbType = DatabaseTypes.find((el) => el.key === service.sub);
        const appState = $store.state.globalState.app;
        const currentDatabaseType =
          $store.state.databaseState.databaseCommonState.currentDatabaseType;
        let databaseTabs = appState.currentSideNav.navTabs.find(
          (item) => item.activeTab === currentDatabaseType.key,
        );
        const currentSubType = databaseTabs?.tabs.find(
          (subtype) => subtype.key === category,
        );
        $store.commit(
          'databaseState/databaseCommonState/setCurrentDatabaseType',
          dbType,
        );
        $store.commit(
          'databaseState/databaseCommonState/setCurrentDatabaseService',
          selectedService,
        );
        category &&
          $store.commit(
            'databaseState/detail/setCurrentSubType',
            currentSubType,
          );
        break;
      }
      case 'M':
        $store.commit(
          'mobileState/mobileCommonState/setCurrentMobileService',
          selectedService,
        );
        break;
      case 'Q': {
        const mqType = messageQueueList.find((mq) => mq.key === service.sub);
        $store.commit('mqState/mqCommonState/setCurrentMQType', mqType);
        $store.commit(
          'mqState/mqCommonState/setCurrentMQService',
          selectedService,
        );
        break;
      }
      case 'S':
        $store.dispatch(
          'syntheticState/commonState/SELECT_SYNTHETIC_SERVICE',
          selectedService,
        );
        break;
      case 'K': {
        $store.commit(
          'k8State/k8CommonState/setCurrentCluster',
          selectedService,
        );
        break;
      }
      case 'V': {
        if (to.name == 'details') {
          $store
            .dispatch('vmState/vmCommonState/SET_CURRENT_VM', params)
            .then(() => {
              $store.commit(
                'vmState/vmCommonState/SET_CURRENT_SUBTYPE',
                SubTypes.LINUX,
              );
            })
            .then((res) => {
              $store.commit(
                'vmState/vmCommonState/SET_CURRENT_VM_INSTANCE',
                res,
              );
            });
        } else {
          $store.commit(
            'vmState/vmCommonState/SET_CURRENT_VM_SERVICE',
            selectedService,
          );
          $store.dispatch('vmState/vmCommonState/SET_CURRENT_VM', params);
        }
        break;
      }
      case 'W': {
        const wsmType = WSMTypes.find((el) => el.key === service.sub);
        $store.commit('wsmState/wsmCommonState/setCurrentWSMType', wsmType);
        $store.commit(
          'wsmState/wsmCommonState/setCurrentWSMService',
          selectedService,
        );
        break;
      }
      default:
        redirectToGeneratedAlert(service, selectedService);
    }
  }
}
